import { useState, useEffect } from "react";

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const Item = props => {

    const { name, content, id, direction} = props

    const [height, setHeight] = useState(1);
    const [expanded, setExpanded] = useState(false);

    function toggleMore(e){
        const button = document.getElementById(`expandMore${id}`);
        button.style.transition = "transform 0.3s ease-out"
        if (!expanded){
            button.style.transform = "rotateX(180deg)";
        } else {
            button.style.transform = "none";
        }
        setExpanded(!expanded);
    }

    useEffect(() => {
        setTimeout(() => {
            const real_height = document.getElementById(id).scrollHeight;
            const viewport_height = window.innerHeight;
            setHeight(real_height/viewport_height);
        }, 0);
        // eslint-disable-next-line
    }, [])

    return (
        <li 
            className="testimonial-item"
            data-aos={`fade-${direction}`}
            data-aos-anchor-placement="bottom-bottom"
        >
            <h1 className="testimonial-item-header">
                {name}
            </h1>
            <p className={ expanded ? "testimonial-item-content-expanded" : "testimonial-item-content"} id={id}>
                {content}
            </p>
            { height >= 0.25 && <ExpandMoreIcon id={`expandMore${id}`} onClick={ e => toggleMore(e, id)}/>}
        </li>
    )
}

export default Item;